// extracted by mini-css-extract-plugin
export default {"container":"MessageLayout_container__ywrtG"};